import { apiGetQuiet } from "@/lib/api";

/**
 * Where to send a user after they can use the app (password + 2FA done).
 * No tradable Schwab/paper account → Brokers so they can connect or create paper.
 */
export async function resolvePostLoginPath(needsSetup: boolean): Promise<string> {
  if (needsSetup) return "/setup";
  try {
    const rows = await apiGetQuiet<
      { accountHash: string; paper?: boolean; tradable?: boolean; broker?: string }[]
    >("/accounts");
    const hasAccount = rows.some(
      (a) => a.tradable === true || a.paper === true || a.broker === "schwab",
    );
    if (!hasAccount) return "/brokers/schwab";
  } catch {
    // Don't trap the user if the accounts call fails.
  }
  return "/accounts";
}
